import { render, staticRenderFns } from "./SamlSetting.vue?vue&type=template&id=2f4a82c5&scoped=true"
import script from "./SamlSetting.vue?vue&type=script&lang=js"
export * from "./SamlSetting.vue?vue&type=script&lang=js"
import style0 from "./SamlSetting.vue?vue&type=style&index=0&id=2f4a82c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4a82c5",
  null
  
)

export default component.exports